<template>
  <!-- <div class="crumbs hidden-xs-only"><router-link to="/">首页</router-link> >> <span :class="{active: i == 0}" v-for="(v, i) in list" :key="i" @click="goPage(v, i)">{{v.cnName}} >> </span>{{title}}</div> -->
    <div>
      <div class="header-nav hidden-xs-only">
      <router-link class="tab-item" to="/">首页</router-link> >
      <a class="tab-item" v-for="(v, i) in list" :key="i" @click="goPage(v, i)"> {{v.cnName}} > </a> <span class="hidden-xs-only active">{{title}}</span>
      </div>
      <div class="header-nav hide-pc">
          <router-link to="/"><span class="tab-item">首页</span></router-link> >
          <a class="tab-item" v-for="(v, i) in list" :key="i" @click="goPage(v, i)"> {{v.cnName}} <span v-if="i !==list.length-1">></span> </a>
      </div>
    </div>
  
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    title: {
      type: String,
      default() {
        return ''
      }
    }
  },
  methods: {
    goPage(pData, i) {
      if (i == 0) {
        this.$router.push(`${pData.targetUrl}/${pData.colId}/`)
      }
      if(i === 1) {
        if(pData.cnName === "抗疫故事") {
          this.$router.push(`/battle/${pData.topId}`)
          return;
        }
        if(pData.cnName === "视频") {
          this.$router.push(`/media/${pData.topId}/videolist?colId=1286842676920320`)
          return;
        }
        window.history.back()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header-nav {
  padding: 0 rem(225);
}
.tab-item {
  margin-right: 4px;
}
.active {
  color: #00653E
}
 @media only screen and (min-width: 768px) {
   .hide-pc{
     display: none;
   }
 }
 @media only screen and (max-width: 768px) {
   .hide-pc{
     display: block;
   }
   .header-nav {
      padding: 0 rem(75);
      .tab-item{
        font-size: 14px;
      }
    }
 }
</style>